import Vue from 'vue'
import Vuex from 'vuex'

import {
  details,
  summary,
  upperLimit,
  childrenValid,
  summaryValid,
} from './modules/claim_country'

import { parentsDetailsSelect, parentsValid } from './modules/parents'
import cloud from './modules/cloud'
import memo from './modules/memo'
import specialSupportPlan from './modules/special_support_plan'

Vue.use(Vuex)

type StateType = {
  sidebarShow: string | boolean
  sidebarMinimize: string | boolean
  [key: string]: string | boolean
}
const state: StateType = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
}

const mutations = {
  toggleSidebarDesktop(state: StateType) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state: StateType) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state: StateType, [variable, value]: [string, string | boolean]) {
    state[variable] = value
  },
}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    details,
    summary,
    upperLimit,
    childrenValid,
    summaryValid,
    parentsDetailsSelect,
    parentsValid,
    cloud,
    memo,
    specialSupportPlan,
  },
})
